export default {
  zh: {
    table: {
      total: '总和',
      grandTotal: '总和',
      count: '总数是',
      summary: {
        sum: '和: {val}',
        avg: '平均值: {val}'
      },
      tipForNull: '此列为非必选字段，组中记录均无值'
    }
  },
  en: {
    table: {
      total: 'Total',
      grandTotal: 'Grand Total',
      count: 'Count',
      summary: {
        sum: 'Sum: {val}',
        avg: 'Average: {val}'
      },
      tipForNull:
        'The field is not required. Records in this group have no value for this field.'
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/RealTimeReport_Table/i18n.js